// Utility functions

export function formatNumber(n) {
  if (n == null || isNaN(n)) return '-';
  return Number(n).toLocaleString('en-US');
}

export function formatCurrency(n) {
  if (n == null || isNaN(n)) return '-';
  return '$' + Number(n).toLocaleString('en-US', { maximumFractionDigits: 0 });
}

export function formatSqft(n) {
  if (n == null || isNaN(n) || n === 0) return '-';
  return Number(n).toLocaleString('en-US') + ' sqft';
}

export function formatFeet(n) {
  if (n == null || isNaN(n) || n === 0) return '-';
  return Number(n).toLocaleString('en-US', { maximumFractionDigits: 1 }) + ' ft';
}

export function formatDimensions(front, depth) {
  if ((!front || front === 0) && (!depth || depth === 0)) return '-';
  const f = front ? Number(front).toLocaleString('en-US', { maximumFractionDigits: 1 }) : '?';
  const d = depth ? Number(depth).toLocaleString('en-US', { maximumFractionDigits: 1 }) : '?';
  return `${f} x ${d} ft`;
}

export function formatDate(d) {
  if (!d) return '-';
  const date = new Date(d);
  if (isNaN(date)) return d;
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

export function formatBBL(bbl) {
  if (!bbl || bbl.length !== 10) return bbl || '-';
  return `${bbl[0]}-${bbl.slice(1, 6)}-${bbl.slice(6, 10)}`;
}

export function boroughName(code) {
  const names = { '1': 'Manhattan', '2': 'Bronx', '3': 'Brooklyn', '4': 'Queens', '5': 'Staten Island' };
  return names[String(code)] || 'Unknown';
}

export function landUseLabel(code) {
  const labels = {
    '01': 'One & Two Family', '02': 'Multi-Family Walk-up', '03': 'Multi-Family Elevator',
    '04': 'Mixed Residential & Commercial', '05': 'Commercial & Office',
    '06': 'Industrial & Manufacturing', '07': 'Transportation & Utility',
    '08': 'Public Facilities & Institutions', '09': 'Open Space & Outdoor Recreation',
    '10': 'Parking Facilities', '11': 'Vacant Land',
  };
  return labels[code] || code || '-';
}

export function debounce(fn, ms) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), ms);
  };
}

export function getParam(name) {
  return new URLSearchParams(window.location.search).get(name);
}
